<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters">
      <v-col cols="12" sm="6" md="6" lg="2">
        <v-text-field
          v-model="search"
          @input="debounceSearch"
          prepend-icon="mdi-magnify"
          label="Search here ..."
          single-line
          solo
          hide-details
        >
        </v-text-field>
      </v-col>
      <!-- <v-col cols="12" sm="6" md="6" lg="2">
        <v-select solo :items="allAccounts()" v-model="trading_account_type_id" @input="accountFilter"
          append-icon="mdi-chevron-down" label="Account Types" class="custom-select" item-text="account_type_display"
          item-value="id"></v-select>
      </v-col> -->
      <v-col cols="12" sm="6" md="6" lg="2">
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="date"
          width="290px"
          class=""
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="selectedDatesText"
              placeholder="Date filter"
              prepend-icon="mdi-calendar"
              append-icon="mdi-chevron-down"
              readonly
              v-bind="attrs"
              v-on="on"
              solo
              class="custom-select"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="selectedDates"
            class="custom-date-picker"
            scrollable
            range
          >
            <v-spacer></v-spacer>
            <v-btn
              :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'"
              text
              @click="cancelSelection"
            >
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.dark ? '#fff' : '#131c29'"
              text
              @click="confirmSelection"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="2">
        <v-btn
          @click="fetchData"
          :disabled="isLoading"
          small
          :ripple="false"
          tile
          elevation="0"
          class="custom-btn"
          height="39"
          style="margin-top: 29px; color: white"
          color="#039de9"
        >
          <template v-if="isLoading">
            <v-progress-circular
              indeterminate
              size="15"
              color="white"
              style="margin-right: 5px"
            ></v-progress-circular>
            Fetching<span class="dots"></span>
          </template>
          <template v-else>
            <v-icon color="#fff" left>mdi-refresh</v-icon>
            Refresh
          </template>
        </v-btn>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="4">
        <ul>
          <li>
            <span>Total Manager Commission:</span>
            <span>{{ formattedAllNumber(summaries?.totalProfit) || 0 }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card
          class="rounded-0 elevation-0"
          :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'"
        >
          <v-sheet
            class="transactionTable depositTableForTransaction"
            :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'"
          >
            <v-data-table
              :headers="headers"
              :items="trades"
              :server-items-length="pagination?.total || 10"
              :options.sync="filterOptions"
              :loading="isLoading"
              :items-per-page="filterOptions.itemsPerPage"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:',
              }"
              @update:options="handleOptionsChange"
              disable-sort
            >
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.manager_full_name="{ item }">
                <router-link
                  class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item.client_id}`"
                >
                  {{ item.manager_full_name }} ({{ item.client_id }})
                </router-link>
              </template>
              <template v-slot:item.login="{ item }">
                {{
                  item?.login +
                  " (" +
                  (item.trading_account_type
                    ? item.trading_account_type.substring(0, 3)
                    : "") +
                  ")"
                }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { formatChartDate, formatMySQLDate } from "@/_helpers/formateDate";
import { formatNumber } from "@/_helpers/formatNumber";
import toast from "@/services/Notification";
import {
  ACCOUNTTYPES__ACTIONS,
  MAMWALLET__ACTIONS,
} from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      selectedDates: [],
      selectedDatesText: null,
      filterOptions: {
        page: 1,
        itemsPerPage: 10,
      },
      trading_account_type_id: null,
      headers: [
        // { text: "Manager Name", value: "manager_full_name" },
        { text: "Manager Email", value: "manager_email" },
        { text: "Manager Username", value: "manager_username" },
        { text: "Manager Account", value: "manager_account" },

        { text: "Investor Account", value: "investor_account" },
        { text: "Investor Profit", value: "investor_total_profit" },
        { text: "Profit Sharing (%)", value: "profit_sharing" },
        { text: "Investor Retained", value: "investor_retained_profit" },
        { text: "Manager Commission", value: "amount" },

        { text: "Start Date", value: "start_date" },
        { text: "End Date", value: "end_date" },
        { text: "Created At", value: "created_at" },
      ],

      modal: false,
      // chart options/series as you had them...
      options: {
        /* ... */
      },
      series: [{ name: "", data: [] }],
      refreshInterval: null,
      isTabVisible: true,
    };
  },

  computed: {
    ...mapState("accounttypes", ["accounttypes"]),
    // 👇 use the correct module name here
    ...mapState("mamwallet", [
      "trades",
      "summaries",
      "pagination",
      "isLoading",
    ]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    formatMySQLDate,
    // 👇 use same module name
    ...mapActions("mamwallet", [MAMWALLET__ACTIONS.MANAGERSCOMMISSIONHISTORY]),
    ...mapActions("accounttypes", [ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    allAccounts() {
      const formattedAccounts = this.accounttypes.map((account) => ({
        id: account.id,
        account_type_display: account.account_type_display,
      }));
      return [{ id: "All", account_type_display: "All" }, ...formattedAccounts];
    },

    async fetchData() {
      const parameter = {
        page: this.filterOptions.page || 1,
        limit: this.filterOptions.itemsPerPage || 10,
        search: this.search,
        trading_account_type_id:
          this.trading_account_type_id && this.trading_account_type_id !== "All"
            ? this.trading_account_type_id
            : null,
      };

      if (this.selectedDates?.length === 2) {
        parameter.duration = `${this.selectedDates[0]}to${this.selectedDates[1]}`;
      }

      try {
        await this[MAMWALLET__ACTIONS.MANAGERSCOMMISSIONHISTORY](parameter);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to fetch data. Please try again.");
      }
    },

    handleSearch() {
      this.fetchData();
    },

    generateLast30Days() {
      const dates = [];
      for (let i = 29; i >= 0; i--) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        dates.push(formatChartDate(date.toISOString()));
      }
      return dates;
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    // 👇 IMPORTANT: use the emitted options
    handleOptionsChange(options) {
      this.filterOptions = options;
      this.fetchData();
    },

    getCurrentDate() {
      return new Date().toISOString().split("T")[0];
    },

    cancelSelection() {
      this.modal = false;
      this.selectedDates = [];
      this.selectedDatesText = null;
      this.filterOptions.page = 1;
      this.fetchData();
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        toast.error("Please select both start and end dates");
        return;
      }

      let [startDate, endDate] = this.selectedDates;
      if (new Date(startDate) > new Date(endDate)) {
        [startDate, endDate] = [endDate, startDate];
      }

      this.selectedDatesText = `${startDate} ~ ${endDate}`;
      this.modal = false;
      this.filterOptions.page = 1;
      this.fetchData();
    },

    accountFilter() {
      this.filterOptions.page = 1;
      this.fetchData();
    },
  },

  created() {
    this[ACCOUNTTYPES__ACTIONS.ACCOUNTTYPES]();
  },

  mounted() {
    this.options.xaxis.categories = this.generateLast30Days();
    this.fetchData();
  },

  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
};
</script>

<style scoped>
.dots::after {
  content: "";
  display: inline-block;
  animation: dotsAnimation 1.5s steps(4, end) infinite;
}

@keyframes dotsAnimation {
  0% {
    content: "";
  }

  25% {
    content: ".";
  }

  50% {
    content: "..";
  }

  75% {
    content: "...";
  }

  100% {
    content: "";
  }
}
</style>
